export default "__VITE_ASSET__NJdSCIzJ__"